import React, { useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import ResetPassword from '../Pages/ResetPassword'

function ForgotPasswordModal({ show, setShow }) {
  const [email, setEmail] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [showResetModal, setShowResetModal] = useState(false)
  const URL = 'https://kaasbackend.vetrinahealthcare.com/'

  const handleInputEmail = (e) => {
    setEmail(e.target.value)
  }

  const navigate = useNavigate()

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email)
  }

  const handleForgotPassword = () => {
    if (!validateEmail(email)) {
      setErrorMessage('Please enter a valid email.')
      return
    }

    axios
      .post(`${URL}auth/forgot-password/`, {
        email: email,
      })
      .then((response) => {
        console.log(response)
        sessionStorage.setItem('OTP_duration', response.data.OTP_duration)
        navigate('/reset-password')
      })
      .catch((error) => {
        console.error('There was an error!', error)
        setErrorMessage('An error occurred. Please try again.')
      })
  }

  const handleClose = () => {
    setShow(false)
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName='modal-fade-animation'
      >
        <Modal.Header closeButton>
          <Modal.Title>Forgot Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId='formBasicEmail'>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type='email'
                value={email}
                onChange={handleInputEmail}
                placeholder='Enter email'
              />
            </Form.Group>
            {errorMessage && <p className='text-danger'>{errorMessage}</p>}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: '#7D52A0' }}
            onClick={handleForgotPassword}
          >
            Send Reset Link
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Render ResetPassword Modal */}
      {showResetModal && (
        <Modal
          show={showResetModal}
          onHide={() => setShowResetModal(false)}
          size='lg'
          centered // Center the modal
          dialogClassName='modal-fade-animation' // Applying the same animation class
        >
          <Modal.Header closeButton>
            <Modal.Title>Reset Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ResetPassword />{' '}
            {/* Display the ResetPassword component inside the modal */}
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

export default ForgotPasswordModal
